import React, { FC, SVGAttributes } from 'react'

const ChevronLeftIcon: FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7.22148 8L11.2939 11.9605L10.0403 13.1765L4.70571 8L10.0403 2.82353L11.2939 4.04047L7.22148 8Z"
            fill="white"
        />
    </svg>
)

export default ChevronLeftIcon
